import { ButtonList } from '../button-list';

export class DatatableButton extends ButtonList {
  name = 'data-tables';
}
